export default "<p>\n  color-cells-cartera works!\n</p>\n";